import { render, staticRenderFns } from "./PrintQR.vue?vue&type=template&id=ef606ca2&scoped=true"
import script from "./PrintQR.vue?vue&type=script&lang=js"
export * from "./PrintQR.vue?vue&type=script&lang=js"
import style0 from "./PrintQR.vue?vue&type=style&index=0&id=ef606ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef606ca2",
  null
  
)

export default component.exports